<template>
    <VizyBlocks>
        <template #quote="{author, text}">
            <DelayHydration>
                <LazyBaseQuote
                    :author="author"
                    :quote="text"
                />
            </DelayHydration>
        </template>

        <template #button="{ linkField }">
            <DelayHydration>
                <LazyBaseButton
                    v-if="linkField"
                    class="base-button--tertiary"
                    :element="CraftLink"
                    :link="linkField"
                />
            </DelayHydration>
        </template>

        <template #imageRepeater="{ imageGallery, caption }">
            <DelayHydration>
                <LazyVizyBlocksContentBuilderGallery
                    :images="imageGallery"
                    :caption="caption"
                />
            </DelayHydration>
        </template>

        <template #illustrationGrid="{ illustrationGridContent }">
            <IllustrationGrid :items="illustrationGridContent">
                <IllustrationItem
                    v-for="illustration in illustrationGridContent"
                    :key="illustration?.title"
                    :illustration="illustration"
                    :class="illustration?.sticker?.length > 12 ? 'sticker__title--small' : ''"
                >
                    <template
                        v-if="illustration?.sticker"
                        #offer
                    >
                        {{ illustration?.sticker }}
                    </template>
                    <template #title>
                        {{ illustration?.title }}
                    </template>
                    <template #description>
                        {{ illustration?.description }}
                    </template>
                    <template #cta>
                        {{ illustration?.linkField?.text }}
                    </template>
                </IllustrationItem>
            </IllustrationGrid>
        </template>

        <template #imageSlider="{ slides, title, description, aspectRatio }">
            <DelayHydration>
                <VizyBlocksContentBuilderImageSlider
                    :images="slides"
                    :title="title"
                    :description="description"
                    :aspect-ratio="aspectRatio"
                />
            </DelayHydration>
        </template>

        <template #videoEmbed="{ image, videoUrl }">
            <BaseVideoEmbed
                :poster-image="image?.[0]"
                :url="videoUrl"
            />
        </template>

        <template #wideImage="{ image }">
            <DelayHydration>
                <LazyBaseImage
                    v-if="image"
                    :image="image[0]"
                    sizes="(min-width: 1440px) 1253px, 87vw"
                />
            </DelayHydration>
        </template>
        <template #faq="{ faq }">
            <h2 v-if="faq?.[0]?.title">
                {{ faq?.[0]?.title }}
            </h2>
            <BaseAccordion :items="faq?.[0]?.items" />
        </template>

        <template #map="{ mapBlock }">
            <MapBlock
                v-if="mapBlock?.[0]?.markers"
                :markers="mapBlock?.[0]?.markers"
            >
                <template
                    v-if="mapBlock?.[0]?.description"
                    #description
                >
                    {{ mapBlock[0].description }}
                </template>
            </MapBlock>
        </template>

        <template #review="{ review }">
            <VizyBlocksContentBuilderReview :review="review" />
        </template>

        <template #enquiryForm="{ enquiryForm }">
            <EnquiryForm
                :enquiry-type="enquiryForm?.[0]?.enquiryType"
                :postmark-address="enquiryForm?.[0]?.postmarkAddress"
                :postmark-server-api-token="enquiryForm?.[0]?.postmarkServerApiToken"
                :postmark-stream="enquiryForm?.[0]?.postmarkStream"
            />
        </template>

        <template #promoBlock="{ promoBlock }">
            <PromoBlock
                v-for="(promoBlockRow, index) in promoBlock"
                id="meetings-events"
                :key="index"
                class="property__section"
                :background-color="promoBlockRow?.backgroundColor"
                :pending="pending"
                :image="promoBlockRow?.image?.[0]"
                :image-position="promoBlockRow?.imagePosition"
                :link="promoBlockRow?.linkField"
            >
                <template
                    v-if="promoBlockRow?.title"
                    #title
                >
                    {{ promoBlockRow?.title }}
                </template>

                <template
                    v-if="promoBlockRow?.description"
                    #description
                >
                    {{ promoBlockRow?.description }}
                </template>

                <template
                    v-if="promoBlockRow?.linkField?.url || promoBlockRow?.linkField?.element"
                    #text
                >
                    <BaseArrowLink
                        :element="CraftLink"
                        :link="promoBlockRow?.linkField"
                        label-position="right"
                    >
                        {{ promoBlockRow?.linkField.text }}
                    </BaseArrowLink>
                </template>
            </PromoBlock>
        </template>
    </VizyBlocks>
</template>

<script setup>
const CraftLink = resolveComponent('CraftLink');
</script>

<style lang="less">

.vizy-blocks-content-builder-slider {
    .slider__item {
        max-width: 43%;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
}

.vizy-blocks__block[data-type='promoBlock'] {
    grid-column: 1/-1;

    @media screen and (min-width: 90rem) {
        margin-inline: calc((100vw - var(--grid-maxWidth-page) - var(--scrollbar-width)) / 2 * -1);
    }
}
</style>